export var IdButtonType;
(function (IdButtonType) {
    IdButtonType["ButtonRectangleExtraSmall"] = "btn-rect-xsmall";
    IdButtonType["ButtonRectangleSmall"] = "btn-rect-small";
    IdButtonType["ButtonRectangleSmallVertical"] = "btn-rect-small-vertical";
    IdButtonType["ButtonRectangleMedium"] = "btn-rect-medium";
    IdButtonType["ButtonRectangleLarge"] = "btn-rect-large";
    IdButtonType["ButtonRectangleLargeThick"] = "btn-rect-large-thick";
    IdButtonType["ButtonRectangleExtraLargeThin"] = "btn-rect-xlarge-thin";
    IdButtonType["ButtonRectangleExtraLarge"] = "btn-rect-xlarge";
    IdButtonType["ButtonSquareExtraSmall"] = "btn-square-xsmall";
    IdButtonType["ButtonSquareSmall"] = "btn-square-small";
    IdButtonType["ButtonSquareMedium"] = "btn-square-medium";
    IdButtonType["ButtonSquareLarge"] = "btn-square-large";
    IdButtonType["ButtonSquareExtraLarge"] = "btn-square-xlarge";
})(IdButtonType || (IdButtonType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/base-button/IdButtonType.ts
// module id = 45
// module chunks = 3